import { useState, useEffect } from 'react';
import { adminAPI } from '../api';

export default function AdminDashboard() {
  const [providers, setProviders] = useState([]);
  const [tab, setTab] = useState('pending');
  const [loading, setLoading] = useState(true);
  const [notes, setNotes] = useState({});
  const [busy, setBusy] = useState({});

  const load = (status) => {
    setLoading(true);
    adminAPI.providers({ status }).then(r=>setProviders(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  };
  useEffect(()=>load(tab),[tab]);

  const approve = async (id) => {
    setBusy(b=>({...b,[id]:true}));
    try { await adminAPI.approve(id, { notes: notes[id]||'' }); load(tab); }
    catch(e) { alert(e.response?.data?.error||'Failed'); }
    setBusy(b=>({...b,[id]:false}));
  };
  const reject = async (id) => {
    const reason = prompt('Rejection reason:');
    if (!reason) return;
    setBusy(b=>({...b,[id]:true}));
    try { await adminAPI.reject(id, { reason }); load(tab); }
    catch(e) { alert(e.response?.data?.error||'Failed'); }
    setBusy(b=>({...b,[id]:false}));
  };

  const TABS = [['pending','Pending'],['standard','Standard'],['certified','Certified'],['elite','Elite'],['rejected','Rejected']];

  return (
    <div className="page-container">
      <div style={{marginBottom:28}}>
        <div className="section-title">Admin Dashboard</div>
        <div className="section-sub">Provider verification and platform management</div>
      </div>

      <div style={{display:'flex',gap:4,marginBottom:24,background:'rgba(255,255,255,0.03)',padding:4,borderRadius:8,flexWrap:'wrap'}}>
        {TABS.map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)}
            style={{flex:1,minWidth:80,padding:'8px',borderRadius:6,fontSize:13,fontWeight:500,border:'none',cursor:'pointer',
              background:tab===v?'rgba(0,194,255,0.15)':'transparent',color:tab===v?'#1E7FD4':'#8899AA',transition:'all 0.2s'}}>
            {l}
          </button>
        ))}
      </div>

      {loading ? <div style={{textAlign:'center',padding:60}}><span className="spinner"/></div>
      : providers.length===0 ? (
        <div className="card" style={{textAlign:'center',padding:'40px 20px',color:'#445566'}}>No {tab} providers.</div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:14}}>
          {providers.map(p=>(
            <div key={p.id} className="card" style={{padding:20}}>
              <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',flexWrap:'wrap',gap:12}}>
                <div style={{flex:1}}>
                  <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap',marginBottom:8}}>
                    <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:18,fontWeight:700}}>{p.real_name}</span>
                    <span style={{fontSize:12,color:'#8899AA'}}>{p.code_id}</span>
                    <span style={{fontSize:11,fontWeight:600,padding:'3px 8px',background:'rgba(0,194,255,0.1)',color:'#1E7FD4',borderRadius:4}}>{p.tier}</span>
                  </div>
                  <div style={{fontSize:13,color:'#8899AA',marginBottom:6}}>
                    {p.email} · {p.phone} · {p.market_name}
                  </div>
                  <div style={{fontSize:13,color:'#AAB8C8',marginBottom:8}}>
                    {p.experience_years} years · ${p.rate_hr}/hr · {p.specialty}
                  </div>
                  {p.insurance_policy && (
                    <div style={{fontSize:12,color:'#556677',marginBottom:6}}>
                      🛡 {p.insurance_provider||'Insurance'}: {p.insurance_policy} ({p.insurance_amount})
                    </div>
                  )}
                  {(p.certifications||[]).filter(Boolean).length>0 && (
                    <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:8}}>
                      {p.certifications.filter(Boolean).map(c=><span key={c} className="badge badge-cert">{c}</span>)}
                    </div>
                  )}
                  {p.references_json && (() => {
                    try { const refs = JSON.parse(p.references_json||'[]');
                      return refs.length>0 && <div style={{fontSize:12,color:'#445566'}}>References: {refs.join(' | ')}</div>;
                    } catch { return null; }
                  })()}
                  {p.admin_notes && <div style={{fontSize:12,color:'#6DBE45',marginTop:6}}>Notes: {p.admin_notes}</div>}
                </div>
                <div style={{display:'flex',flexDirection:'column',gap:8,flexShrink:0}}>
                  <div style={{fontSize:11,color:'#445566'}}>Applied: {new Date(p.created_at).toLocaleDateString()}</div>
                  {tab==='pending' && <>
                    <textarea rows={2} placeholder="Admin notes (optional)"
                      value={notes[p.id]||''} onChange={e=>setNotes(n=>({...n,[p.id]:e.target.value}))}
                      style={{fontSize:12,padding:'6px 8px',minWidth:180,resize:'vertical'}} />
                    <button className="btn btn-sm btn-primary" onClick={()=>approve(p.id)} disabled={busy[p.id]}>
                      {busy[p.id]?<span className="spinner"/>:'✓ Approve'}
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={()=>reject(p.id)} disabled={busy[p.id]}>
                      ✗ Reject
                    </button>
                  </>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
